import type { RecentSpenderListProjection } from '@api'
import type { Row } from '@tanstack/table-core'

import EditIcon from '@/assets/icons/icon-edit.svg'
import TrashIcon from '@/assets/icons/icon-trash.svg'
import { IconButton } from '@/modules/chatting/ui/components/icon-button'

export interface RecentSpenderActionButtonProps {
  row: Row<RecentSpenderListProjection>
  onEdit: (list: RecentSpenderListProjection) => void
  onDelete: (list: RecentSpenderListProjection) => void
}

export const RecentSpenderActionButton: React.FC<
  RecentSpenderActionButtonProps
> = ({ row, onEdit, onDelete }) => {
  return (
    <div className="flex justify-end gap-4">
      <IconButton
        className="text-primary-500 h-5 w-5"
        onClick={() => onEdit(row.original)}
        icon={EditIcon}
        testId="edit-list-action"
      />
      <IconButton
        className="text-danger-default h-5 w-5"
        onClick={() => onDelete(row.original)}
        icon={TrashIcon}
        testId="delete-list-action"
      />
    </div>
  )
}
